import Loader from '@classify/react-core-components/Loader';
import { getLoadableModule } from 'Modules/lazy-common';

export default getLoadableModule(
  () => import(/* webpackChunkName: "universalSearch" */ './UniversalSearch'),
  <Loader size={16} />
);
